import LinkWrapper from '../LinkWrapper';
import { useMenuNavigation } from './sidebar/useMenuNavigation';
import { useQuickAccessShortcuts } from './sidebar/useQuickAccessShortcuts';

/**
 * Barra de navegación inferior, sólo en móvil. Reserva su alto con la variable
 * `--bottom-nav-height` (que vale 0 desde md) igual que competitions.
 */
export default function BottomNav(): React.ReactElement | null {
    const { go } = useMenuNavigation();
    const shortcuts = useQuickAccessShortcuts();

    if (shortcuts.length === 0) return null;

    return (
        // Con Copilot, el hueco de la derecha deja el último acceso fuera de su timón.
        <nav className="sporttia-bottom-nav bg-card border-border copilot:pr-20 fixed inset-x-0 bottom-0 z-50 h-(--bottom-nav-height) border-t md:hidden">
            <div className="flex h-full items-center justify-around">
                {shortcuts.map((shortcut) => (
                    <div
                        key={shortcut.id}
                        className="flex min-w-0 flex-1 justify-center"
                    >
                        <LinkWrapper
                            href={shortcut.href}
                            callback={() => go({ url: shortcut.href })}
                        >
                            <span
                                id={`mobile-${shortcut.id}`}
                                className="text-muted-foreground flex w-full flex-col items-center gap-1 px-1 py-2"
                            >
                                {shortcut.icon}
                                <span className="block max-w-full truncate text-center text-xs">
                                    {shortcut.label}
                                </span>
                            </span>
                        </LinkWrapper>
                    </div>
                ))}
            </div>
        </nav>
    );
}
